import React from 'react';
import classNames from 'classnames';

import styles from './ProductQuantity.module.scss';

const MIN_VALUE = 1;
const MAX_VALUE = 9;

type Props = {
  qty: number;
  setQty: (data: number) => void;
  classes?: { container?: string };
};

/**
 * Product page of website. Contains details product data.
 */
export default function ProductQuantity({
  qty,
  setQty,
  classes,
}: Props): JSX.Element {
  function decrement() {
    if (qty > MIN_VALUE) setQty(qty - 1);
  }

  function increment() {
    if (qty < MAX_VALUE) setQty(qty + 1);
  }

  return (
    <div className={classNames(styles.container, classes?.container)}>
      <button
        className={classNames(styles.button, styles.left)}
        disabled={qty <= MIN_VALUE}
        onClick={decrement}
      />
      <input type="text" className={styles.field} value={qty} disabled />
      <button
        className={classNames(styles.button, styles.right)}
        disabled={qty >= MAX_VALUE}
        onClick={increment}
      />
    </div>
  );
}
